import Image from 'next/image'

import { formatPhoneMasked } from '@/shared/lib/validation/phone'
import { Button } from '@/shared/ui'

import { formatMinutesSeconds } from '../../lib/format-minutes-seconds'
import { useAuthByPhoneContext } from '../auth-by-phone/auth-by-phone.context'
import { CodeInput } from '../code-input/code-input'
import { ResendButton } from '../resend-button/resend-button'
import { RuleNotation } from '../rule-notation/rule-notation'

import cl from './style.module.scss'

export const CodeBySms = () => {
	const {
		phone,
		smsCode,
		smsCodeError,
		isLoading,
		isNewUser,
		resendCooldown,
		isCooldown,
		onCodeChange,
		requestSmsCode,
		goToPhone
	} = useAuthByPhoneContext()

	if (!phone) return null

	return (
		<div className={cl.root}>
			<div className={cl.wrapper}>
				<p className={cl.title}>Введите код из SMS</p>
				<p className={cl.text}>
					Вам поступит четырехзначный код на номер{' '}
					<small>
						{formatPhoneMasked(phone)}
						<Button theme="link" onClick={goToPhone}>
							Изменить
						</Button>
					</small>
				</p>
				<CodeInput code={smsCode} onChange={onCodeChange} isError={!!smsCodeError} />
				{smsCodeError && <p className={cl.error}>{smsCodeError}</p>}
				{isNewUser && <RuleNotation />}
				<ResendButton onResend={requestSmsCode} isLoading={isLoading} isDisabled={isCooldown}>
					Отправить повторно через {formatMinutesSeconds(resendCooldown)}
				</ResendButton>
			</div>
			<div className={cl.imgWrapper}>
				<Image
					src={'https://storage.yandexcloud.net/tf-bitrix-upload/iport/sms_pc.png'}
					alt={''}
					width={286}
					height={286}
					className={cl.img}
				/>
				<div className={cl.linear}></div>
			</div>
		</div>
	)
}
